import { AspectRatio, Flex, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'

const Guarantee = () => {
  return (
    <Flex
      w="100%"
      justifyContent={{
        base: 'center',
        md: 'space-between'
      }}
      pt={{
        base: '40px',
        sm: '10px',
        md: '40px',
        lg: '60px'
      }}
      pb={0}
      flexDir={{
        base: 'column-reverse',
        md: 'row'
      }}
      alignItems={{
        base: 'center',
        md: 'flex-end'
      }}
      gap={{
        base: 0
      }}
    >
      <VStack
        w={{
          base: '100%',
          sm: '80%',
          md: '30%'
        }}
        position="relative"
        mt="28px"
        justifyContent="flex-end"
        mb={0}
      >
        <AspectRatio
          w={{
            base: '180px',
            sm: '260px',
            md: '300px',
            lg: '380px',
            xl: '440px'
          }}
          ratio={345 / 480}
          position="relative"
          zIndex={10}
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/tumbler-guarantee-1711633174577.png"
            alt="tumbler guarantee"
            fill
          />
        </AspectRatio>
      </VStack>
      <VStack
        w={{
          base: '100%',
          sm: '80%',
          md: '60%'
        }}
        mt={{
          base: '0px',
          sm: '40px',
          md: '0px'
        }}
        alignItems="flex-start"
        pb={{
          base: 0,
          md: '23px',
          lg: '60px'
        }}
      >
        <AspectRatio
          w={{
            base: '40px',
            sm: '50px',
            md: '60px',
            lg: '70px',
            xl: '80px'
          }}
          ratio={1 / 1}
          position="relative"
          zIndex={10}
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/icon-droplet-1711633174578.png"
            alt="icon droplet"
            fill
          />
        </AspectRatio>
        <Text
          textStyle="gripProblemTitle"
          textTransform="uppercase"
          textAlign="left"
          w="100%"
        >
          LEAK-PROOF LID
        </Text>
        <Text textStyle="gripContentSmall" textAlign="left" w="100%" mb={5}>
          Worry less about leaks and spills. Our tumbler features a leak-proof
          lid that securely seals your drinks, making it a hassle-free addition
          to your daily routine.
        </Text>
        <AspectRatio
          w={{
            base: '40px',
            sm: '50px',
            md: '60px',
            lg: '70px',
            xl: '80px'
          }}
          ratio={1 / 1}
          position="relative"
          zIndex={10}
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/icon-bpa-1711633174578.png"
            alt="icon bpa"
            fill
          />
        </AspectRatio>
        <Text
          textStyle="gripProblemTitle"
          textTransform="uppercase"
          textAlign="left"
          w="100%"
        >
          BPA-FREE FOR PEACE OF MIND
        </Text>
        <Text textStyle="gripContentSmall" textAlign="left" w="100%">
          Your health and safety matter to us. Constructed with BPA-free
          materials, guaranteeing that your drinks remain free from harmful
          chemicals.
        </Text>
      </VStack>
    </Flex>
  )
}

export default Guarantee
